import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { GenericTimeSlot } from '../../models';
import { TooltipModule } from 'primeng/tooltip';
import { NgxAimTimePickerClass } from './ngx-aim-time-picker.class';

@Component({
  selector: 'ngx-aim-time-picker',
  standalone: true,
  imports: [ReactiveFormsModule, DropdownModule, TooltipModule],
  templateUrl: './ngx-aim-time-picker.component.html',
  styleUrls: ['./ngx-aim-time-picker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimTimePickerComponent extends NgxAimTimePickerClass implements OnInit {
  @Input()
  override set isDisabled(isDisabled: boolean) {
    if (isDisabled) {
      this.form.disable();
      this.toolTip = 'Select day frist';
    } else {
      this.form.enable();
      this.toolTip = '';
    }
  }

  @Input()
  override set timeSlots(timeSlots: GenericTimeSlot[]) {
    this._timeSlots = timeSlots;
    this.form.reset();
  }

  @Input()
  override set selectedTime(timeSlot: GenericTimeSlot) {
    if (timeSlot) {
      this.form.patchValue({ timeSlot });
    }
  }

  @Output()
  override onTimeChange = new EventEmitter<GenericTimeSlot>();

  ngOnInit() {
    this.init();
  }
}
